import { basicEnum } from "./base";

export const DataImportStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "waiting",
    },
    {
        label: "Berhasil",
        value: "success",
    },
    {
        label: "Dibatalkan",
        value: "canceled",
    },
    {
        label: "Gagal",
        value: "failed",
    },
    {
        label: "Tidak Valid",
        value: "invalid",
    },
]);

export namespace DataImportStatusEnum {
    export type Labels = (typeof DataImportStatusEnum)["labels"][number];
    export type Values = (typeof DataImportStatusEnum)["values"][number];
}
